export default "__VITE_ASSET__CdkjnmG2__"